import { render, staticRenderFns } from "./ProductInventory.vue?vue&type=template&id=6267ca40&scoped=true"
import script from "./ProductInventory.vue?vue&type=script&lang=js"
export * from "./ProductInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6267ca40",
  null
  
)

export default component.exports